module.exports = __webpack_public_path__ + "img/coupon-1.eb155a1e.png";